import React from 'react';

interface IInstagramProps {
    height: string
    url: string
}

//350 je minimum, co FB dovoluje
const WIDTH = 350;

function Instagram({ height, url }: IInstagramProps) {
    return (
        <div className="stx-media-wrapper">
            {
                // eslint-disable-next-line jsx-a11y/iframe-has-title
                <iframe
                    className='stx-chatbot-chat-instagram'
                    src={`${url}/embed`}
                    width={WIDTH}
                    height={height}
                    frameBorder="0"
                    scrolling="no">

                </iframe>
            }
        </div>
    );
}

export default Instagram;
